<template>
  <app-page-container title="پرونده ها">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-4 text-left ml-5">
        <v-icon class="ml-2" color="darkColor" v-if="soundIsPlay" @click="stopMusic()">
          mdi-play-circle
        </v-icon>
        <v-icon class="ml-2" v-else>mdi-play-circle-off</v-icon>
        <v-icon class="ml-2" color="darkColor" @click="reloadData()">mdi-cached</v-icon>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="body-card card-width pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header :headers="hospitalTableInformationHeader" :items="hospitalMissions"
                      :items-per-page="hospitalMissions.length" height="80vh" :item-class="itemRowBackground"
                      :search="searchTitle" :hide-default-footer="true" multi-sort class="elevation-0">
                      <template v-slot:[`item.icon`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon :color="item.color" v-bind="attrs" v-on="on">
                              mdi-ambulance mdi-18px
                            </v-icon>
                          </template>
                          <span>وضعیت {{ item.missionRank }}</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-menu rounded="lg" v-if="item.diagnosisFlag == true">
                          <template v-slot:activator="{ on: menu, attrs }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on: tooltip }">
                                <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                  v-on="{ ...tooltip, ...menu }">
                                  mdi-information
                                </v-icon>
                              </template>
                              <span>مشاهده پرونده</span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item dense v-for="(actionItems, index) in item.allDiagnosis" :key="('m', index)"
                              @click="setActionType(actionItems.title, item)">
                              <v-list-item-content>
                                <v-list-item-title>{{ actionItems.title }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-tooltip top v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer" @click="
                              exportMission(
                                item.id,
                                item.patientId,
                                item.allDiagnosis,
                                item.diagnosisFlag,
                              )
                              " v-bind="attrs" v-on="on">
                              mdi-information
                            </v-icon>
                          </template>
                          <span>مشاهده پرونده</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="enableAddEditFunction(1, item.patientId)" v-bind="attrs" v-on="on">
                              mdi-clipboard-text
                            </v-icon>
                          </template>
                          <span>پذیرش</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog v-model="admissionModal" width="500" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-ambulance</v-icon>
                  <span class="modal-title-text mr-2">پذیرش</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12" class="mt-n5">
                  <v-checkbox v-model="hospitalAdmission.admissionWithoutConsent" label="پذیرش بدون رضایت"></v-checkbox>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-textarea type="text" v-model="hospitalAdmission.note" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="توضیحات"
                    class="input-label" rows="4" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allUserHospitals" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="بیمارستان"
                    v-model="hospitalAdmission.hospitalId" autocomplete="off"
                    prepend-inner-icon="mdi-hospital-building mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAdmissionFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component style="z-index: 999999999999999999999 !important" ref="snackRef" :snakTimeOut="snakTimeOut"
          :snackColor="snackColor" :snackText="snackText" :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import HospitalMissionsHelper from '@/Helpers/Hospital/HospitalMissionsHelper';
import HospitalAdmissionsMixin from '@/Mixins/Hospital/HospitalAdmissionsMixin';
import UserMixin from '@/Mixins/BaseInformation/UserMixin';
export default {
  name: 'HospitalMissions',
  title: 'بیمارستان',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    AppPageContainer,
  },
  mixins: [
    ShearedMixin,
    snackBar,
    ShearedHelper,
    HospitalMissionsHelper,
    HospitalAdmissionsMixin,
    UserMixin,
  ],
  created() {
    this.$root.$refs.HospitalMissions = this;
    this.$mainSignalr.bus.$on('HospitalMainList', this.fHospitalMainList);
    this.$mobileSignalr.bus.$on('HospitalMainList', this.fHospitalMainList);
  },
  beforeDestroy() {
    clearInterval(this.playInterval);
    this.playInterval = null;
    this.$mainSignalr.bus.$off('HospitalMainList', this.fHospitalMainList);
    this.$mobileSignalr.bus.$off('HospitalMainList', this.fHospitalMainList);

    delete this.$root.$refs.HospitalMissions;
  },

  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getAllHospitalAdmissionsActiveFunction();
    },
    fHospitalMainList: function () {
      clearInterval(this.playInterval);
      this.soundIsPlay = false;
      this.redFlag = false;
      this.yellowFlag = false;
      this.playInterval = null;
      this.getAllHospitalAdmissionsActiveFunction();
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}



>>>.row-back-red {
  background-color: #ffafaf !important;
}

>>>.row-back-yellow {
  background-color: #ffe290 !important;
}
</style>
